var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "week-days",
      class: {
        "is-invalid": _vm.invalid,
        grow: _vm.grow,
      },
    },
    [
      _c("div", { staticClass: "c-input-label" }, [
        _vm._v(" Дни недели "),
        _c(
          "div",
          { staticClass: "c-input-label-fullname" },
          [
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover",
                    content: "Дни недели",
                    placement: "bottom",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover',\n          content: 'Дни недели',\n          placement: 'bottom',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: { size: "iconic", icon: "info" },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "days" },
        _vm._l(_vm.days, function (day, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "day",
              class: {
                active: _vm.value.includes(i),
              },
              on: {
                click: function ($event) {
                  return _vm.toggle(i)
                },
              },
            },
            [_vm._v(" " + _vm._s(day) + " ")]
          )
        }),
        0
      ),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }